import React, { useEffect } from 'react';
import { useParams }        from 'react-router';
import { Link }             from 'react-router-dom';
import scrollToComponent    from 'react-scroll-to-component';
import { getRoute }         from 'pursuit/routes/routes';

export default function Events(props) {
    const { scrollTo } = props;
    const params = useParams();

    const scrollReferences = [];
    let scrollToLabel = '';

    useEffect(() => {
        if (typeof scrollTo !== 'undefined') {
            scrollToLabel = scrollTo;
        }

        scrollToComponent(
            scrollReferences[scrollToLabel], {
                offset: -110,
                align: 'top',
                duration: 300,
            }
        );
    });

    return (
        <section role="main" className="events">

            <div className="grid-center">
                <div className="col-11">
                    <div className="grid-center">
                        <div className="col-8_xs-11_md-8">

                            <h2 className="content-title justify-center minor-margin--bottom">
                                Upcoming Events
                            </h2>

                            <div className="grid-center">
                                <div className="col justify-center">
                                    There are no upcoming events at this time.
                                </div>
                                <div className="col-11 major-margin--bottom">
                                </div>
                            </div>
                        </div>

                        <div className="col-4_xs-11_md-4">

                            <h2 className="content-title justify-center minor-margin--bottom">
                                Past Events
                            </h2>

                            <div className="grid-center">
                                <div className="col-11">
                                    <ul className="styled">
                                        <li>
                                            <Link
                                                to={getRoute('eventsPastEvent', {event: 'womens-wellness'})}
                                                className="link">
                                                    Women's Wellness Event
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to={getRoute('eventsPastEvent', {event: '2nd-anniversary'})}
                                                className="link">
                                                    2 Year Anniversary Open House
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to={getRoute('eventsPastEvent', {event: 'pre-teen-athlete-stretch'})}
                                                className="link">
                                                    Pre-Teen Athlete Stretch and Strengthen Class (Boys)
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to={getRoute('eventsPastEvent', {event: 'post-natal-pilates'})}
                                                className="link">
                                                    Post-Natal Pilates
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to={getRoute('eventsPastEvent', {event: 'rest-and-digest'})}
                                                className="link">
                                                    Rest & Digest: 101 <span className="text-small"> - Wednesday, August 15th, 2018</span>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

        </section>
    )
}
